var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "62px",
    viewBox: "0 0 91 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-719.000000, -119.000000)",
    strokeWidth: 2,
    stroke: "#043F93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(720.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.71428571 C0,1.71428571 10.8764825,1.87459231e-15 22.2077922,0 C33.5391019,-1.86013753e-15 44.4155844,1.71428571 44.4155844,1.71428571 L44.4155844,60 C44.4155844,60 33.5821797,58.2857154 22.2077922,58.2857143 C10.8334047,58.2857131 0,60 0,60 L0,1.71428571 Z",
    id: "Rectangle-941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4155844,1.71428571 C44.4155844,1.71428571 55.2920669,1.87459231e-15 66.6233766,0 C77.9546863,-1.86013753e-15 88.8311688,1.71428571 88.8311688,1.71428571 L88.8311688,60 C88.8311688,60 77.9977642,58.2857154 66.6233766,58.2857143 C55.2489891,58.2857131 44.4155844,60 44.4155844,60 L44.4155844,1.71428571 Z",
    id: "Rectangle-941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.000000, 14.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9050797,6.66112513 C3.13649396,3.28890083 5.9513581,0.625 9.375,0.625 L15.8602941,0.625 L15.8602941,6.6636058 C16.6460093,6.77681927 17.25,7.45672622 17.25,8.2617323 L17.25,8.7382677 C17.25,9.55745065 16.6427232,10.2341529 15.8449203,10.3388749 C15.613506,13.7110992 12.7986419,16.375 9.375,16.375 C5.94439449,16.375 3.13593283,13.7079991 2.90504586,10.3385293 C2.11186584,10.2320117 1.5,9.54850482 1.5,8.7382677 L1.5,8.2617323 C1.5,7.44254935 2.10727682,6.76584709 2.9050797,6.66112513 Z",
    id: "Rectangle-2325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10336538,16.375 L6,18.5227273 L3.3732478,18.5227273 C2.02523737,18.5227273 0.9375,19.5529811 0.9375,20.8238636 L0.9375,23.125 L17.8125,23.125 L17.8125,20.8238636 C17.8125,19.5555671 16.7219786,18.5227273 15.3767522,18.5227273 L12.4254808,18.5227273 L11.3221154,16.375",
    id: "Rectangle-2327"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(51.000000, 21.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75,1.75 L30,1.75",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25,6.25 L25.5,6.25",
    id: "Line"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/Passport.bb3db03d1ba62fb3141ffd7da6150532.svg";
export { ForwardRef as ReactComponent };